(ns renolit-roofing-service.view.installer-service-information
  (:require [cljc.java-time.instant :as jt.instant]
            [malli.util :as mu]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.components :refer [back-link entity-section
                                                               collapsable-section]]
            [renolit-roofing-service.layout.display-item :as layout.display-item]
            [renolit-roofing-service.layout.display-item.impl]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.form-item.date-picker]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.service.service :as srv.service]
            [renolit-roofing-service.shared.util.time :as shared.time]
            [renolit-roofing-service.view :as view]
            [renolit-roofing-service.view.installer-service-information.zone :as view.zone]))

(def path-params-schema
  [:map
   [:id
    [:uuid]]])

(def ^:const route-config
  {:name [:installer-service-information]
   :auth-req? true
   :parameters {:path path-params-schema}
   :controllers [{:parameters {:path (mu/keys path-params-schema)}
                  :start #(rf/dispatch [::view.on-enter %])
                  :stop #(rf/dispatch [::view.on-leave %])}]})

(rf/reg-event-fx
 ::view.on-enter
 (fn [_ [_ opts]]
   (let [service-id (get-in opts [:path :id])]
     {:fx [[:dispatch [::srv.service/fetch-service-by-id service-id]]
           [:dispatch [::set-active-tab :project]]]})))

(rf/reg-event-fx
 ::view.on-leave
 (fn [{:keys [db]} _]
   {:db (-> db
            (dissoc :zones :zones-bounds :default-map-viewport :gmaps/read-only? :gmaps/bridge-registry)
            (dissoc ::service-saving?))
    :fx [[:dispatch [::srv.service/clear-service]]]}))

(rf/reg-event-fx
 ::set-active-tab
 (fn [{:keys [db]} [_ tab]]
   (let [prev-tab (:installer-service-info-active-tab db)
         leaving-zones? (and (= prev-tab :zones) (not= tab :zones))
         entering-zones? (= tab :zones)]
     {:db (cond-> (assoc db :installer-service-info-active-tab tab)
            leaving-zones? (-> (dissoc :zones :zones-bounds :gmaps/read-only? :gmaps/bridge-registry)))
      :fx (cond-> []
            entering-zones? (conj [:dispatch [::view.zone/initialize-zones-map]]))})))

(rf/reg-sub
 ::active-tab
 (fn [db _]
   (get db :installer-service-info-active-tab :project)))

(rf/reg-event-db
 ::set-service-saving
 (fn [db [_ saving?]]
   (assoc db ::service-saving? saving?)))

(rf/reg-sub
 ::service-saving?
 (fn [db _]
   (get db ::service-saving? false)))

(rf/reg-sub
 ::project
 :<- [::srv.service/current-service]
 (fn [service _]
   (:project service)))

(defn- project-basic-data
  [project]
  [:div.si-info
   [layout.display-item/main
    {:type :text
     :state project
     :path [:name]
     :label-transl-kw :domain.project/project-name}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:account-name]
     :label-transl-kw :domain.project/account-name}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type]
     :label-transl-kw :domain.project/building-type}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type-text]
     :label-transl-kw :domain.project/building-type-text}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:product]
     :label-transl-kw :domain.project/product}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:product-text]
     :label-transl-kw :domain.project/product-text}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:end-customer-name]
     :label-transl-kw :domain.project/end-customer-name}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:number]
     :label-transl-kw :domain.project/project-number}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:owner]
     :label-transl-kw :domain.project/service-manager}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:total-roof-area]
     :label-transl-kw :domain.project/total-roof-area}]
   [layout.display-item/main
    {:type :text
     :value (shared.time/format-date (:closing-date @project) {})
     :label-transl-kw :domain.project/closing-date}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:type]
     :label-transl-kw :domain.project/type}]])

(defn- project-building-address
  [project]
  [:div.si-info
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-country]
     :label-transl-kw :domain.project/building-country}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-region]
     :label-transl-kw :domain.project/building-region}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-state]
     :label-transl-kw :domain.project/building-state}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-city]
     :label-transl-kw :domain.project/building-city}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-zip]
     :label-transl-kw :domain.project/building-zip}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-street]
     :label-transl-kw :domain.project/building-street}]])

(defn- project-warranty
  [project]
  [:div.si-info
   [layout.display-item/main
    {:type :text
     :state project
     :path [:warranty-number]
     :label-transl-kw :domain.project/warranty-number}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:insured-period-years]
     :label-transl-kw :domain.project/insured-period-years}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:material-type]
     :label-transl-kw :domain.project/material-type}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:thickness]
     :label-transl-kw :domain.project/thickness}]
   [layout.display-item/main
    {:type :text
     :value (shared.time/format-date (:valid-until @project) {})
     :label-transl-kw :domain.project/valid-until}]])

(defn- project-meteo
  [project]
  [:div.si-info
   [layout.display-item/main
    {:type :text
     :state project
     :path [:avg-anual-temp]
     :label-transl-kw :domain.project/avg-anual-temperature}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:max-temp]
     :label-transl-kw :domain.project/max-temperature}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:min-temp]
     :label-transl-kw :domain.project/min-temperature}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:accumulated-precipitation]
     :label-transl-kw :domain.project/accumulated-precipitation}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:hail-days]
     :label-transl-kw :domain.project/hail-days}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:avg-sunlight-hours]
     :label-transl-kw :domain.project/avg-sunlight-hours}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:solar-irradiation]
     :label-transl-kw :domain.project/solar-irradiation}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:avg-wind-speed]
     :label-transl-kw :domain.project/avg-wind-speed}]])

(defn- project-roof-lifecycle
  [project]
  [:div.si-info
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type]
     :label-transl-kw :page.project.details.expected-product-life}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type]
     :label-transl-kw :page.project.details.actual-product-life}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type]
     :label-transl-kw :page.project.details.critical-window}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type-text]
     :label-transl-kw :page.project.details.end-of-guarantee}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:product]
     :label-transl-kw :page.project.details.end-of-critical-window}]])

(defn- project-tab
  [project]
  [:div.installer-service-information__tab-content
   [entity-section
    {:title (str "1. " (t [:page.project.details.basic-project-data]))}
    [project-basic-data project]]
   [entity-section
    {:title (str "2. " (t [:page.project.details.building-address]))}
    [project-building-address project]]
   [entity-section
    {:title (str "3. " (t [:page.project.details.warranty]))}
    [project-warranty project]]
   [entity-section
    {:title (str "4. " (t [:page.project.details.meteorological-indicators]))}
    [project-meteo project]]
   [entity-section
    {:title (str "5. " (t [:page.project.details.roof-life-cycle-estimate]))}
    [project-roof-lifecycle project]]])

(defn- service-basic-data
  [service]
  [:div.service-section
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:name]
     :label-transl-kw :domain.service/name}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:origin]
     :label-transl-kw :domain.service/origin}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:reason]
     :label-transl-kw :domain.service/reason}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:reason-text]
     :label-transl-kw :domain.service/reason-text}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:objective]
     :label-transl-kw :domain.service/objective}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:manager]
     :label-transl-kw :domain.service/responsible}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:authorized-diagnostic-contractor]
     :label-transl-kw :domain.service/contractor}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:inspector]
     :label-transl-kw :domain.service/inspector}]
   [layout.form/item
    {:context :installer-service-info
     :type :date-picker
     :date-type :instant
     :state service
     :path [:last-diagnosis-date]
     :label-transl-kw :domain.service/last-diagnosis-date
     :max-date :today}]
   [layout.form/item
    {:context :installer-service-info
     :type :date-picker
     :date-type :instant
     :state service
     :path [:last-maintenance-date]
     :label-transl-kw :domain.service/last-maintenance-date}]])

(defn- service-building-info
  [service]
  [:div.service-section.service-section--half
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:building-height]
     :label-transl-kw :domain.building/height}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:roof-slope]
     :label-transl-kw :domain.building/inclination}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:upstand]
     :label-transl-kw :domain.building/upstand}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:service-area]
     :label-transl-kw :domain.building/surface}]])

(defn- service-client-data
  [service]
  [:div.service-section
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:customer-name]
     :label-transl-kw :domain.client/name}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:customer-profile]
     :label-transl-kw :domain.client/profile}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:company-owner]
     :label-transl-kw :domain.client/company-owner}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:company-industry]
     :label-transl-kw :domain.client/company-industry}]])

(defn- service-roof-structure
  [service]
  [:div.service-section
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:roofing-membrane]
     :label-transl-kw :domain.roof/membrane}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:application-method]
     :label-transl-kw :domain.roof/application-method}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:support]
     :label-transl-kw :domain.roof/support}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:protective-glue]
     :label-transl-kw :domain.roof/protective-glue}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:vapor-barrier]
     :label-transl-kw :domain.roof/vapor-barrier}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:glue-type]
     :label-transl-kw :domain.roof/glue-type}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:thermal-insulation]
     :label-transl-kw :domain.roof/thermal-insulation}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:separation-layer]
     :label-transl-kw :domain.roof/separation-layer}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:color]
     :label-transl-kw :domain.roof/color}]
   [layout.form/item
    {:context :installer-service-info
     :type :input
     :state service
     :path [:fixation]
     :label-transl-kw :domain.roof/fixation}]])

(def ^:private editable-service-keys
  [:name :origin :reason :reason-text :objective :manager :inspector
   :authorized-diagnostic-contractor :last-diagnosis-date :last-maintenance-date
   :building-height :roof-slope :upstand :service-area
   :customer-name :customer-profile :company-owner :company-industry
   :roofing-membrane :application-method :support :protective-glue
   :vapor-barrier :glue-type :thermal-insulation :separation-layer :color :fixation])

(rf/reg-event-fx
 ::save-service
 (fn [_ [_ service-id form-state]]
   (let [service-data (select-keys form-state editable-service-keys)]
     {:fx [[:dispatch [::set-service-saving true]]
           [:dispatch [::srv.service/update-service service-id service-data
                       {:on-success-evt [::save-service-success]
                        :on-failure-evt [::save-service-failure]}]]]})))

(rf/reg-event-fx
 ::save-service-success
 (fn [_ _]
   {:fx [[:dispatch [::set-service-saving false]]]}))

(rf/reg-event-fx
 ::save-service-failure
 (fn [_ _]
   {:fx [[:dispatch [::set-service-saving false]]]}))

(defn- js-date->instant
  [v]
  (when v
    (if (instance? js/java.time.Instant v)
      v
      (jt.instant/of-epoch-milli (.getTime v)))))

(defn- coerce-service-dates
  [service]
  (-> service
      (update :last-diagnosis-date js-date->instant)
      (update :last-maintenance-date js-date->instant)))

(defn- service-tab*
  [service]
  (let [edit-state (r/atom (coerce-service-dates @service))]
    (fn [service]
      (let [saving? @(rf/subscribe [::service-saving?])]
        [:div.installer-service-information__tab-content
         [entity-section
          {:title (str "1. " (t [:page.service.add.service-data]))}
          [service-basic-data edit-state]]
         [entity-section
          {:title (str "2. " (t [:page.service.add.building-information]))}
          [service-building-info edit-state]]
         [entity-section
          {:title (str "3. " (t [:page.service.add.customer-data]))}
          [service-client-data edit-state]]
         [entity-section
          {:title (str "4. " (t [:page.service.add.roof-structure]))}
          [service-roof-structure edit-state]]
         [:div.installer-service-information__actions
          [:button.btn.btn--primary.btn--full-width
           {:type "button"
            :disabled saving?
            :on-click (fn []
                        (when-not saving?
                          (rf/dispatch [::save-service (:id @service) @edit-state])))}
           (if saving?
             [:span.installer-service-information__btn-spinner]
             (t [:page.installer.service-info/save]))]]]))))

(defn- service-tab
  [service]
  [service-tab* service])

(defn- build-zone-index
  [zones]
  (into {} (map (juxt :id :name)) zones))

(defn- group-reviews-for-display
  [reviews zone-index]
  (reduce
   (fn [acc {:keys [wp wp-type type zone-id tasks]}]
     (let [zone-name (get zone-index zone-id "")
           poi-type (if (= type :focused) :focused-revision :general-revision)]
       (reduce
        (fn [inner-acc {:keys [task-type comment]}]
          (update-in inner-acc [wp wp-type poi-type task-type]
                     (fnil conj [])
                     {:zone-name zone-name
                      :comment comment}))
        acc
        tasks)))
   {}
   reviews))

(defn- visit-program-zone-pill
  [zone-name]
  [:span.zone-pill zone-name])

(defn- visit-program-task-block
  [task-type occurrences]
  [:div.task-card
   [:div.task-card__title
    (t [(keyword (str "domain.choices.task-type/" (name task-type)))])]
   (for [{:keys [zone-name comment]} occurrences]
     ^{:key (str task-type "-" zone-name "-" comment)}
     [:div.task-card__body
      [:div.task-card__zones
       [visit-program-zone-pill zone-name]]
      (when (and comment (seq comment))
        [:div.task-card__comments
         [layout.icon/icon {:key :message :class "task-card__comments-icon"}]
         [:span.task-card__comments-text comment]])])])

(defn- visit-program-poi-type-section
  [poi-type tasks-by-task-type]
  [:div.si-poi
   [:span (t [(keyword (str "domain.choices.revision-type/" (name poi-type)))])]
   (for [[task-type occurrences] (sort-by (fn [[k _]] (name k)) tasks-by-task-type)]
     ^{:key (str poi-type "-" task-type)}
     [visit-program-task-block task-type occurrences])])

(defn- visit-program-wp-type-section
  [wp-type poi-types]
  [collapsable-section
   {:title (t [(keyword (str "domain.choices.wp-type/" (name wp-type)))])
    :start-open true
    :class "collapsable-section--nested"}
   [:<>
    (for [poi-type (sort (keys poi-types))]
      (let [tasks-by-task-type (get poi-types poi-type)]
        (when (seq tasks-by-task-type)
          ^{:key (str wp-type "-" poi-type)}
          [visit-program-poi-type-section poi-type tasks-by-task-type])))]])

(defn- visit-program-wp-section
  [wp wp-types]
  [collapsable-section
   {:title (t [(keyword (str "domain.choices.wp/" (name wp)))])
    :start-open true}
   [:<>
    (for [[wp-type poi-types] (sort-by (fn [[k _]] (name k)) wp-types)]
      ^{:key (str wp "-" wp-type)}
      [visit-program-wp-type-section wp-type poi-types])]])

(defn- visit-program-tab
  [service]
  (let [reviews (or (:reviews @service) [])
        zones (or (:zones @service) [])
        zone-index (build-zone-index zones)
        grouped (group-reviews-for-display reviews zone-index)]
    [:div.installer-service-information__tab-content
     (if (seq grouped)
       [:div.si-visits
        (for [[wp wp-types] (sort-by (fn [[k _]] (name k)) grouped)]
          ^{:key (str wp)}
          [visit-program-wp-section wp wp-types])]
       [:p (t [:common/no-data])])]))

(def tabs-config
  [{:key :project    :label-kw :common/project}
   {:key :service    :label-kw :common/service}
   {:key :zones      :label-kw :page.zone.zones}
   {:key :visit-program :label-kw :common/visit-program}])

(defn- tab-bar
  []
  (let [active-tab (rf/subscribe [::active-tab])]
    [:div.si-tabs.tab-bar.tab-bar--pill
     (doall
      (for [{:keys [key label-kw]} tabs-config]
        ^{:key key}
        [:div.si-tabs__tab.tab-bar__tab
         {:class (when (= key @active-tab) "tab-bar__tab--selected")
          :on-click #(rf/dispatch [::set-active-tab key])}
         (t [label-kw])]))]))

(defn- main
  []
  (let [service (rf/subscribe [::srv.service/current-service])
        project (rf/subscribe [::project])
        active-tab (rf/subscribe [::active-tab])
        service-id (:id @service)]
    [:div.user_layout
     [:div.user_layout_header
      [:a.back-link {:href (nav/href [:installer-service-detail] {:id service-id})}
       [layout.icon/icon {:key :back}]]
      [:h3
       [layout.icon/icon {:key :info}]
       (t [:common.information])]
      [:div]]
     [:div.installer-service-information
      [tab-bar]
      (if @service
        (case @active-tab
          :project [project-tab project]
          :service [service-tab service]
          :zones [view.zone/zones-tab service]
          :visit-program [visit-program-tab service]
          [project-tab project])
        [:div.loading (t [:common.loading])])]]))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
